import React, { useState } from 'react';
import { Link, createSearchParams } from 'react-router-dom';
import {
	Button,
	Typography,
	Input,
	Dropdown,
	ChevronRight,
	Checkbox,
	RadioButtons,
	IconPopup,
} from '@adac-mp/components';
import { getUrlBasePath } from '@adac-mp/shared';

export const Home = () => {
	const [checked, setChecked] = useState(false);
	const [checkedFilled, setCheckedFilled] = useState(true);
	const [radioButton, setRadioButton] = useState('');
	const [radioButtonFilled, setRadioButtonFilled] = useState('Filled 1');
	const params = createSearchParams();
	params.set('step', '1');
	return (
		<>
			<div className="p-2">
				<Link to={getUrlBasePath(`/camper-mautbox/configuration`)}>
					<Button size="lg">DKV Mautbox bestellen</Button>
				</Link>
				<Link to={getUrlBasePath(`/vignette-cze/onboarding`)}>
					<Button size="lg">Tschechische Vignette bestellen</Button>
				</Link>
				<Link to={getUrlBasePath(`/vignette-svn/onboarding`)}>
					<Button size="lg">Slowenische Vignette bestellen</Button>
				</Link>
				<Link to={getUrlBasePath(`/oesterreich/onboarding`)}>
					<Button size="lg">Österreichische Vignette bestellen</Button>
				</Link>
				<Link to={getUrlBasePath(`/schweiz/onboarding`)}>
					<Button size="lg">Schweiz Vignette bestellen</Button>
				</Link>
				<Link to={getUrlBasePath(`/one-cart/configure`, params)}>
					<Button size="lg">One Cart</Button>
				</Link>
			</div>
			<div className="p-2">
				<Typography variant="header" size="h3" color="title" component="h1" className="p-2">
					Base components
				</Typography>
				<Typography variant="header" size="xl" color="title" component="h1" className="p-2">
					IconPopup
				</Typography>
				<IconPopup
					title="Kostenaufteilung"
					type="help"
					paddingX="large"
					content={{
						title: 'Hello World',
						content: (
							<div>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum sequi eum placeat,
								fugit eligendi, ab consequatur amet, delectus earum facilis consectetur repellendus eos
								nostrum nisi veniam totam quaerat. Cumque facere beatae eaque numquam incidunt quod
								explicabo laudantium vero ipsam quisquam laboriosam deleniti earum doloribus, eligendi
								quibusdam sint distinctio delectus debitis?
							</div>
						),
					}}
				/>
				<Typography variant="header" size="xl" color="title" component="h1">
					Buttons
				</Typography>
				<br />
				<Button loading size="lg">
					Click me
				</Button>
				<Button disabled size="lg">
					Click Me
				</Button>
				<Button>
					Click me <ChevronRight />
				</Button>
				<Button disabled>Click Me</Button>
				<Button size="sm" variant="secondary">
					Click Me
				</Button>
				<Button disabled size="sm" variant="secondary">
					Click Me
				</Button>
				<Button size="xs" variant="shy">
					Click Me
				</Button>
				<Button disabled size="xs" variant="shy">
					Click Me
				</Button>
				<Button size="sm" variant="overlay">
					Click Me 2
				</Button>
				<Button disabled size="sm" variant="overlay">
					Click Me
				</Button>
				<Button size="sm" variant="tertiary">
					Click Me
				</Button>
				<Button disabled size="sm" variant="tertiary">
					Click Me
				</Button>
				<Button fullWidth size="lg">
					Click me
				</Button>
			</div>
			<div className="p-2">
				<Typography variant="header" size="xl" color="title" component="h1" className="py-2">
					Typography
				</Typography>
				<br />
				<Typography variant="header" size="h2" color="title" component="h1">
					This is a text
				</Typography>
				<Typography variant="title" size="xl" component="h2">
					This is a text
				</Typography>
				<Typography>This is a text</Typography>
				<Typography variant="abstract" color="inactiveText" size="sm" component="p" className="text-gray-300">
					This is a text
				</Typography>
			</div>
			<div className="p-2">
				<Typography variant="header" size="xl" color="title" component="h1">
					Inputs
				</Typography>
				<br /> <Input placeholder="placeholder" size="lg" />
				<Input placeholder="placeholder" />
				<Input placeholder="placeholder" size="mdEven" />
				<Input placeholder="placeholder" size="sm" />
				<Input placeholder="placeholder" size="xs" />
				<Input placeholder="placeholder" size="lg" value="test" />
				<Input placeholder="placeholder" value="test" />
				<Input placeholder="placeholder" size="mdEven" value="test" />
				<Input placeholder="placeholder" size="sm" value="test" />
				<Input placeholder="placeholder" size="xs" value="test" />
				<Input disabled placeholder="placeholder" value="test value" />
				<Input />
				<Typography variant="header" size="xl" color="title" component="h1">
					Dropdowns
				</Typography>
				<br />
				<Dropdown
					placeholder="select 123"
					size="lg"
					items={[
						{ value: '1', label: 'value 1' },
						{ value: '2', label: 'value 2' },
					]}
				/>
				<Dropdown
					placeholder="select 123"
					items={[
						{ value: '1', label: 'value 1' },
						{ value: '2', label: 'value 2' },
					]}
				/>
				<Dropdown
					placeholder="select 123"
					size="sm"
					items={[
						{ value: '1', label: 'value 1' },
						{ value: '2', label: 'value 2' },
					]}
				/>
				<Dropdown
					placeholder="select 123"
					size="xs"
					items={[
						{ value: '1', label: 'value 1' },
						{ value: '2', label: 'value 2' },
					]}
				/>
			</div>
			<br />
			<Typography variant="header" size="xl" color="title" component="h1">
				Checkboxes
			</Typography>
			<br />
			<div className="flex gap-1.5 p-2">
				<Checkbox label="Default" checked={checked} setChecked={setChecked} />
				<Checkbox disabled label="Disabled" />
				<Checkbox label="Filled" checked={checkedFilled} setChecked={setCheckedFilled} />
				<Checkbox defaultChecked disabled label="Filled disabled" />
			</div>
			<div className="flex gap-1.5 p-2">
				<Checkbox size="md" label="Click me!" checked={checked} setChecked={setChecked} />
				<Checkbox disabled size="md" label="Disabled" />
				<Checkbox size="md" label="Filled" checked={checkedFilled} setChecked={setCheckedFilled} />
				<Checkbox defaultChecked disabled size="md" label="Filled disabled" />
			</div>
			<div className="flex gap-1.5 p-2">
				<Checkbox size="sm" label="Click me!" checked={checked} setChecked={setChecked} />
				<Checkbox disabled size="sm" label="Disabled" />
				<Checkbox size="sm" label="Filled" checked={checkedFilled} setChecked={setCheckedFilled} />
				<Checkbox defaultChecked disabled size="sm" label="Filled disabled" />
			</div>
			<div className="flex gap-1.5 p-2">
				<Checkbox size="xs" label="Click me!" checked={checked} setChecked={setChecked} />
				<Checkbox disabled size="xs" label="Disabled" />
				<Checkbox size="xs" label="Filled" checked={checkedFilled} setChecked={setCheckedFilled} />
				<Checkbox defaultChecked disabled size="xs" label="Filled disabled" />
			</div>
			<br />
			<Typography variant="header" size="xl" color="title" component="h1">
				Radio Buttons
			</Typography>
			<br />
			<div className="flex gap-1.5 p-2">
				<RadioButtons
					size="sm"
					options={[
						['Id1', 'Default 1'],
						['Id2', 'Default 2'],
					]}
					value={radioButton}
					setValue={setRadioButton}
				/>
				<RadioButtons
					size="sm"
					options={[
						{ id: '1', label: 'Option 1', disabled: true },
						{ id: '2', label: 'Option 2', disabled: true },
					]}
				/>
				<RadioButtons
					size="sm"
					defaultValue="Filled 1"
					options={['Filled 1', 'Filled 2']}
					value={radioButtonFilled}
					setValue={setRadioButtonFilled}
				/>
				<RadioButtons
					size="sm"
					defaultValue="2"
					options={[
						{ id: '1', label: 'Filled disabled  1', disabled: true },
						{ id: '2', label: 'Filled disabled  2', disabled: true },
					]}
				/>
			</div>
			<div className="flex gap-1.5 p-2">
				<RadioButtons
					size="xs"
					options={[
						['Id1', 'Default 1'],
						['Id2', 'Default 2'],
					]}
					value={radioButton}
					setValue={setRadioButton}
				/>
				<RadioButtons
					size="xs"
					options={[
						{ id: '1', label: 'Option 1', disabled: true },
						{ id: '2', label: 'Option 2', disabled: true },
					]}
				/>
				<RadioButtons
					size="xs"
					defaultValue="Filled 1"
					options={['Filled 1', 'Filled 2']}
					value={radioButtonFilled}
					setValue={setRadioButtonFilled}
				/>
				<RadioButtons
					size="xs"
					defaultValue="2"
					options={[
						{ id: '1', label: 'Filled disabled  1', disabled: true },
						{ id: '2', label: 'Filled disabled  2', disabled: true },
					]}
				/>
			</div>
		</>
	);
};
